<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12 col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Lista wybranych kategorii kreatora</h4>
            </div>
          </div>
        </div>

        <div class="widget-content">
          <div class="custom-table table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th width="80">Wybierz</th>
                  <th>ID</th>
                  <th>Kategoria</th>
                  <th>Jednostka</th>
                  <th>Wymiary zakupowe</th>
                  <th width="120">Akcja</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="category in categories" :key="category.id">
                  <td>
                    <input type="checkbox" class="form-check-input" :checked="isSelected(category.id)"
                      :disabled="saving === category.id" @change="toggleCategory(category.id, $event.target.checked)">
                  </td>

                  <td>
                    {{ category.id }}
                  </td>

                  <td>
                    {{ category.name }}
                  </td>

                  <td>
                    <template v-if="isSelected(category.id)">
                      <span v-if="getCategoryUnit(category.id)">
                        {{ getCategoryUnit(category.id).name }}
                      </span>

                      <span v-else class="text-muted">
                        Nie wybrano
                      </span>
                    </template>
                  </td>

                  <td>
                    <template v-if="isSelected(category.id)">
                      <span v-if="wymiaryZakupowe[category.id]?.length">
                        <span v-for="(wymiar, index) in wymiaryZakupowe[category.id]" :key="wymiar.id">
                          {{ formatDimension(wymiar) }}<span v-if="index < wymiaryZakupowe[category.id].length - 1">,
                          </span>
                        </span>
                      </span>

                      <span v-else class="text-muted">
                        Brak wymiarów
                      </span>
                    </template>
                  </td>

                  <td>
                    <button v-if="isSelected(category.id)" type="button" class="btn btn-sm btn-primary"
                      @click="openDimensionsModal(category)">
                      Edytuj
                    </button>
                  </td>
                </tr>

                <tr v-if="categories.length === 0">
                  <td colspan="6" class="text-center">
                    Brak kategorii.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showDimensionsModal" class="modal fade show" style="display: block;" tabindex="-1" aria-modal="true"
      role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title">
              {{ selectedCategory?.name }}
            </h5>

            <button type="button" class="btn-close" @click="closeDimensionsModal"></button>
          </div>

          <div class="modal-body">

            <div class="mb-4">
              <label class="form-label fw-bold">
                Jednostka artykułu
              </label>

              <div class="d-flex gap-2">
                <select v-model="selectedUnitId" class="form-select" :disabled="savingUnit">
                  <option :value="null">
                    Wybierz jednostkę
                  </option>

                  <option v-for="unit in units" :key="unit.id" :value="unit.id">
                    {{ unit.name }}
                  </option>
                </select>

                <button type="button" class="btn btn-success" :disabled="savingUnit || !selectedUnitId"
                  @click="saveCategoryUnit">
                  {{ savingUnit ? 'Zapisywanie...' : 'Zapisz' }}
                </button>
              </div>
            </div>

            <hr>

            <div class="mb-4">
              <button v-if="modalDimensions.length < 2" type="button" class="btn btn-success"
                @click="showAddDimension = true">
                Dodaj jednostkę zakupową
              </button>
            </div>

            <div v-if="showAddDimension" class="border rounded p-3 mb-3">
              <div class="row g-3">
                <div :class="isSquareMeterUnit ? 'col-12 col-md-5' : 'col-12'">
                  <label class="form-label">
                    Długość
                  </label>

                  <div class="input-group">
                    <input v-model.number="newDimension" type="number" min="1" class="form-control"
                      placeholder="np. 6000">

                    <span class="input-group-text">mm</span>
                  </div>
                </div>

                <div v-if="isSquareMeterUnit" class="col-12 col-md-5">
                  <label class="form-label">
                    Szerokość
                  </label>

                  <div class="input-group">
                    <input v-model.number="newDimensionWidth" type="number" min="1" class="form-control"
                      placeholder="np. 3000">

                    <span class="input-group-text">mm</span>
                  </div>
                </div>

                <div :class="isSquareMeterUnit
                  ? 'col-12 col-md-2 d-flex align-items-end'
                  : 'col-12'">
                  <div class="d-flex gap-2 flex-wrap w-100">
                    <button type="button" class="btn btn-success" :disabled="savingDimension" @click="addDimension">
                      Dodaj
                    </button>

                    <button type="button" class="btn btn-secondary" :disabled="savingDimension"
                      @click="cancelAddDimension">
                      Anuluj
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="modalDimensions.length" class="table-responsive">
              <table class="table table-bordered align-middle">
                <thead>
                  <tr>
                    <th>Długość</th>

                    <th v-if="isSquareMeterUnit">
                      Szerokość
                    </th>

                    <th width="180">
                      Akcja
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="dimension in modalDimensions" :key="dimension.id">
                    <td>
                      <template v-if="editingDimension === dimension.id">
                        <div class="d-flex align-items-center gap-2">
                          <input v-model.number="editDimensionValue" type="number" min="1" class="form-control">

                          <span>mm</span>
                        </div>
                      </template>

                      <template v-else>
                        {{ dimension.dlugosc }} mm
                      </template>
                    </td>

                    <td v-if="isSquareMeterUnit">
                      <template v-if="editingDimension === dimension.id">
                        <div class="d-flex align-items-center gap-2">
                          <input v-model.number="editDimensionWidthValue" type="number" min="1" class="form-control">

                          <span>mm</span>
                        </div>
                      </template>

                      <template v-else>
                        {{ dimension.szerokosc }} mm
                      </template>
                    </td>

                    <td>
                      <template v-if="editingDimension === dimension.id">
                        <button type="button" class="btn btn-sm btn-success me-2" :disabled="savingDimension"
                          @click="saveDimension(dimension)">
                          Zapisz
                        </button>

                        <button type="button" class="btn btn-sm btn-secondary" :disabled="savingDimension"
                          @click="cancelEditDimension">
                          Anuluj
                        </button>
                      </template>

                      <template v-else>
                        <button type="button" class="btn btn-sm btn-primary me-2" :disabled="savingDimension"
                          @click="startEditDimension(dimension)">
                          Edytuj
                        </button>

                        <button type="button" class="btn btn-sm btn-danger" :disabled="savingDimension"
                          @click="deleteDimension(dimension)">
                          Usuń
                        </button>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="text-center text-muted py-4">
              Brak jednostek zakupowych.
            </div>

          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeDimensionsModal">
              Zamknij
            </button>
          </div>

        </div>
      </div>
    </div>

    <div v-if="showDimensionsModal" class="modal-backdrop fade show"></div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import axios from "axios";

export default {
  components: {
    AppLayout
  },

  props: {
    categories: {
      type: Array,
      default: () => []
    },

    kategorie: {
      type: Array,
      default: () => []
    },

    units: {
      type: Array,
      default: () => []
    },

    jednostkiKategorii: {
      type: Object,
      default: () => ({})
    },

    wymiaryZakupowe: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      selectedCategories: [...this.kategorie],
      saving: null,

      showDimensionsModal: false,
      selectedCategory: null,

      modalDimensions: [],

      showAddDimension: false,
      newDimension: null,
      newDimensionWidth: null,

      editingDimension: null,
      editDimensionValue: null,
      editDimensionWidthValue: null,

      savingDimension: false,

      selectedUnitId: null,
      savingUnit: false
    };
  },

  computed: {
    isSquareMeterUnit() {
      return Number(this.selectedUnitId) === 3;
    }
  },

  methods: {
    isSelected(categoryId) {
      return this.selectedCategories.includes(categoryId);
    },

    getCategoryUnitId(categoryId) {
      return this.jednostkiKategorii[categoryId] ?? null;
    },

    getCategoryUnit(categoryId) {
      const unitId = this.getCategoryUnitId(categoryId);

      if (!unitId) {
        return null;
      }

      return this.units.find(
        unit => Number(unit.id) === Number(unitId)
      ) || null;
    },

    formatDimension(dimension) {
      if (
        Number(this.getCategoryUnitId(dimension.category_id)) === 3 &&
        dimension.szerokosc
      ) {
        return `${dimension.dlugosc}x${dimension.szerokosc} mm`;
      }

      return `${dimension.dlugosc} mm`;
    },

    async toggleCategory(categoryId, selected) {
      const oldState = this.isSelected(categoryId);

      if (selected && !oldState) {
        this.selectedCategories.push(categoryId);
      }

      if (!selected && oldState) {
        this.selectedCategories = this.selectedCategories.filter(
          id => id !== categoryId
        );
      }

      this.saving = categoryId;

      try {
        await axios.put(
          this.route('creator.settings.categories'),
          {
            category_id: categoryId,
            selected: selected
          }
        );
      } catch (error) {
        if (selected) {
          this.selectedCategories = this.selectedCategories.filter(
            id => id !== categoryId
          );
        } else {
          this.selectedCategories.push(categoryId);
        }

        console.error(error);
      } finally {
        this.saving = null;
      }
    },

    openDimensionsModal(category) {
      this.selectedCategory = category;

      this.modalDimensions = (
        this.wymiaryZakupowe[category.id] || []
      ).map(dimension => ({
        ...dimension
      }));

      this.selectedUnitId = this.getCategoryUnitId(category.id);

      this.showAddDimension = false;
      this.newDimension = null;
      this.newDimensionWidth = null;

      this.editingDimension = null;
      this.editDimensionValue = null;
      this.editDimensionWidthValue = null;

      this.showDimensionsModal = true;
    },

    closeDimensionsModal() {
      if (this.savingDimension || this.savingUnit) {
        return;
      }

      this.showDimensionsModal = false;
      this.selectedCategory = null;
      this.modalDimensions = [];
      this.showAddDimension = false;
      this.newDimension = null;
      this.newDimensionWidth = null;

      this.editingDimension = null;
      this.editDimensionValue = null;
      this.editDimensionWidthValue = null;

      this.selectedUnitId = null;
    },

    async saveCategoryUnit() {
      if (!this.selectedCategory || !this.selectedUnitId) {
        return;
      }

      this.savingUnit = true;

      try {
        const response = await axios.put(
          this.route('creator.settings.category-unit'),
          {
            category_id: this.selectedCategory.id,
            unit_id: Number(this.selectedUnitId)
          }
        );

        this.jednostkiKategorii[response.data.category_id] =
          response.data.unit_id;

        this.selectedUnitId = response.data.unit_id;

        this.modalDimensions = (
          this.wymiaryZakupowe[this.selectedCategory.id] || []
        ).map(dimension => ({
          ...dimension
        }));
      } catch (error) {
        console.error(error);

        alert(
          error.response?.data?.message ||
          'Nie udało się zapisać jednostki.'
        );
      } finally {
        this.savingUnit = false;
      }
    },

    cancelAddDimension() {
      this.showAddDimension = false;
      this.newDimension = null;
      this.newDimensionWidth = null;
    },

    startEditDimension(dimension) {
      this.editingDimension = dimension.id;
      this.editDimensionValue = dimension.dlugosc;
      this.editDimensionWidthValue = dimension.szerokosc ?? null;
    },

    cancelEditDimension() {
      this.editingDimension = null;
      this.editDimensionValue = null;
      this.editDimensionWidthValue = null;
    },

    async saveDimension(dimension) {
      const length = Number(this.editDimensionValue);

      if (!Number.isInteger(length) || length <= 0) {
        alert('Długość musi być liczbą całkowitą większą od 0.');
        return;
      }

      let width = null;

      if (this.isSquareMeterUnit) {
        width = Number(this.editDimensionWidthValue);

        if (!Number.isInteger(width) || width <= 0) {
          alert('Szerokość musi być liczbą całkowitą większą od 0.');
          return;
        }
      }

      this.savingDimension = true;

      try {
        const response = await axios.put(
          this.route('creator.settings.purchase-dimensions'),
          {
            category_id: this.selectedCategory.id,
            dimensions: [
              {
                id: dimension.id,
                dlugosc: length,
                szerokosc: width
              }
            ]
          }
        );

        this.updateDimensions(
          response.data.wymiaryZakupowe
        );

        this.editingDimension = null;
        this.editDimensionValue = null;
        this.editDimensionWidthValue = null;
      } catch (error) {
        console.error(error);

        alert(
          error.response?.data?.message ||
          'Nie udało się zapisać wymiaru.'
        );
      } finally {
        this.savingDimension = false;
      }
    },

    async addDimension() {
      const length = Number(this.newDimension);

      if (!Number.isInteger(length) || length <= 0) {
        alert('Długość musi być liczbą całkowitą większą od 0.');
        return;
      }

      let width = null;

      if (this.isSquareMeterUnit) {
        width = Number(this.newDimensionWidth);

        if (!Number.isInteger(width) || width <= 0) {
          alert('Szerokość musi być liczbą całkowitą większą od 0.');
          return;
        }
      }

      if (this.modalDimensions.length >= 2) {
        return;
      }

      this.savingDimension = true;

      try {
        const response = await axios.post(
          this.route('creator.settings.purchase-dimensions.add'),
          {
            category_id: this.selectedCategory.id,
            dlugosc: length,
            szerokosc: width
          }
        );

        this.updateDimensions(
          response.data.wymiaryZakupowe
        );

        this.showAddDimension = false;
        this.newDimension = null;
        this.newDimensionWidth = null;
      } catch (error) {
        console.error(error);

        alert(
          error.response?.data?.message ||
          'Nie udało się dodać wymiaru zakupowego.'
        );
      } finally {
        this.savingDimension = false;
      }
    },

    async deleteDimension(dimension) {
      const result = await Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie jednostki zakupowej',
        html: `Czy na pewno chcesz usunąć <strong>${this.formatDimension(dimension)}</strong>?`,
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      });

      if (!result.isConfirmed) {
        return;
      }

      this.savingDimension = true;

      try {
        const response = await axios.delete(
          this.route(
            'creator.settings.purchase-dimensions.delete',
            dimension.id
          )
        );

        this.updateDimensions(
          response.data.wymiaryZakupowe
        );

        Toast.fire({
          toast: true,
          icon: 'success',
          title: 'Jednostka zakupowa została usunięta.',
          position: 'top-end',
          timer: 2500,
          showConfirmButton: false
        });
      } catch (error) {
        console.error(error);

        const message =
          error.response?.data?.message ||
          'Nie udało się usunąć jednostki zakupowej.';

        Toast.fire({
          toast: true,
          icon: 'error',
          title: message,
          position: 'top-end',
          timer: 3500,
          showConfirmButton: false
        });
      } finally {
        this.savingDimension = false;
      }
    },

    updateDimensions(dimensions) {
      const sorted = [...dimensions].sort(
        (a, b) => {
          const lengthA = Number(a.dlugosc);
          const lengthB = Number(b.dlugosc);

          if (lengthA !== lengthB) {
            return lengthA - lengthB;
          }

          return Number(a.szerokosc || 0) - Number(b.szerokosc || 0);
        }
      );

      this.modalDimensions = sorted.map(dimension => ({
        ...dimension
      }));

      this.wymiaryZakupowe[this.selectedCategory.id] = sorted.map(
        dimension => ({
          ...dimension
        })
      );
    }
  }
};
</script>